/* eslint-disable no-shadow */

export enum Breakpoints {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}

export enum ScreenSize {
  xsMin = 0,
  xsMax = 480,
  smMin = 481,
  smMax = 767,
  mdMin = 768,
  mdMax = 1024,
  lgMin = 1025,
  lgMax = 4000,
}
